import { render, staticRenderFns } from "./ChatWelcome.vue?vue&type=template&id=32351ae2&scoped=true"
var script = {}
import style0 from "./ChatWelcome.vue?vue&type=style&index=0&id=32351ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32351ae2",
  null
  
)

export default component.exports